import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import chatify from "../../Assets/Projects/gallery.png";
import stackOverFlow from "../../Assets/Projects/stackOverFlow.png";
import studentDashBoard from "../../Assets/Projects/studentDashBoard.png";
import trustApp from "../../Assets/Projects/trustApp.png";
import foodRecipe from "../../Assets/Projects/foodRecipes.png";
import calculator from "../../Assets/Projects/calculator.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
            <ProjectCard
              imgPath={stackOverFlow}
              isBlog={false}
              title="Stack Overflow Clone"
              description="This is a clone of stack overflow where you can ask and answer questions. You can also upvote and downvote the answers."
              ghLink="https://github.com/dineshkumar-stack"
              demoLink="https://dev-over-flow.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={studentDashBoard}
              isBlog={false}
              title="Student Dashboard"
              description="This is a student dashboard where you can see the details of the students. You can also add, edit and delete the students."
              ghLink="https://github.com/dineshkumar-stack"
              demoLink="https://zen-class-dashboard.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={trustApp}
              isBlog={false}
              title="Blood Donation App"
              description="This is a blood donation app where you can donate blood and also request for blood. You can also see the details of the donors and requesters."
              ghLink="https://github.com/dineshkumar-stack"
              demoLink="https://resplendent-sawine-de4635.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={foodRecipe}
              isBlog={false}
              title="Food Recipe App"
              description="This is a food recipe app where you can see the details of the recipes. You can also add, edit and delete the recipes."
              ghLink="https://github.com/dineshkumar-stack"
              demoLink="https://meal-look.netlify.app/"
            />
          </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Gallery & Dictionary"
              description="Here you search image with detail explaination about the search topic"
              ghLink="https://github.com/dineshkumar-stack/PromiseTask-Gallery"
              demoLink="https://api-gallery-wise-dictionary.netlify.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={calculator}
              isBlog={false}
              title="Calculator"
              description="Feel good UI calculator"
              ghLink="https://github.com/dineshkumar-stack/Workings"
              demoLink="https://calculator4dineshstack.netlify.app/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
